import { render, staticRenderFns } from "./PieChartPlatform.vue?vue&type=template&id=32397ffe&scoped=true&"
import script from "./PieChartPlatform.vue?vue&type=script&lang=js&"
export * from "./PieChartPlatform.vue?vue&type=script&lang=js&"
import style0 from "./PieChartPlatform.vue?vue&type=style&index=0&id=32397ffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32397ffe",
  null
  
)

export default component.exports